/**
 * Filtering form helper
 *
 * @since   1.0.0
 * @package blujay
 */

(function($) {
    $(document).ready(function() {

        var $form = $('form.filters');

        // sanity check
        if ($form.length < 1) return;

        // bind option changes
        var $selects = $('select', $form);
        var $loading = $('.loading', $form);
        var $to = $('[id*="to"]', $form);
        var $from = $('[id*="from"]', $form);
        var $datepickers = $('input.date-picker', $form);

        var to = $to.datepicker({
            changeMonth: true,
			dateFormat: "yy-mm-dd"
        }).on('change', checkDates);
        var from = $from.datepicker({
            changeMonth: true,
			dateFormat: "yy-mm-dd"
        }).on('change', checkDates);



        var dateFormat = "yy-mm-dd";

        $selects.on('change', submitForm);

        /**
         * Submit the form
         *
         * @since 1.0.0
         */
        function submitForm() {
            $form.submit();
            $loading.fadeToggle();
        }

        /**
         * Date comparison
         *
         * @since 1.0.0
         */
        function checkDates(e) {
            switch ($(e.target).attr('id')) {
                case 'date_date_to':
                    from.datepicker("option", "maxDate", getDate(this));
                    setTimeout(function() {
                        from.datepicker("show");
                    }, 100);
                    break;
                case 'date_date_from':
                    to.datepicker("option", "minDate", getDate(this));
                    setTimeout(function() {
                        to.datepicker("show");
                    }, 100);
                    break;
            }
            //submit if both fields are filled out
            if ($.trim($to.val()).length && $.trim($from.val()).length) {
                submitForm();
            }
        }

        function getDate(element) {
            console.log(element);
            var date;
            try {
                date = $.datepicker.parseDate(dateFormat, element.value);
            } catch (error) {
                console.log(error);
                date = null;
            }
            console.log(date);
            return date;
        }

    }); // document.ready
})(jQuery);
